import React, { useCallback, useContext, useEffect } from 'react';
import { HeaderConfigContext } from 'app/App';
import { useAppDispatch, useAppSelector } from 'hooks/store-hooks';
import { systemActions } from 'store/system/slices';
import { RetentionSettingsButton } from './RetentionSettingsButton';
import { RetentionSettingsValues } from '../types';

export const useHeaderRendererWithRetentionSettings = (): void => {
  const dispatch = useAppDispatch();
  const { setHeaderRenderer } = useContext(HeaderConfigContext);

  const loading: boolean = useAppSelector((s: any) => Boolean(s?.settings?.loading));

  const onSave = useCallback(
    (next: Required<RetentionSettingsValues>) => {
      dispatch(systemActions.mediaNodes.requestSetModulClaster(next));
    },
    [dispatch]
  );

  const onReset = useCallback(() => {
    dispatch({ type: 'settings/resetRetention' });
  }, [dispatch]);

  useEffect(() => {
    setHeaderRenderer(<RetentionSettingsButton loading={loading} onSave={onSave} onReset={onReset} />);
    return () => setHeaderRenderer(null);
  }, [setHeaderRenderer, loading, onSave, onReset]);
};
